import { render } from "./custom-fields.vue?vue&type=template&id=785ed608"
import script from "./custom-fields.vue?vue&type=script&lang=js"
export * from "./custom-fields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__